import apiFetch from '@scale/frontend-lib/api-fetch';
import {
  DeleteFraudCenterPermissionRequest,
  UpsertFraudCenterPermissionRequest,
} from '@scale/genai-data-service-client';

export const fetchFraudProfile = async (taskerId: string) => {
  return await apiFetch(null, `corp-api/fraud/tasker`, {
    method: 'GET',
    query: {
      taskerId,
    },
  });
};

export const fetchFraudCenterPermissions = async (): Promise<{ permissions: any[] }> => {
  return await apiFetch(null, `corp-api/fraud/fraud_center_permissions`, {
    method: 'GET',
  });
};

export const upsertFraudCenterPermissions = async (req: UpsertFraudCenterPermissionRequest) => {
  return await apiFetch(null, `corp-api/fraud/fraud_center_permissions`, {
    method: 'POST',
    body: req,
  });
};

export const deleteFraudCenterPermission = async (
  req: DeleteFraudCenterPermissionRequest,
): Promise<void> => {
  return await apiFetch(null, `corp-api/fraud/fraud_center_permissions`, {
    method: 'DELETE',
    body: req,
  });
};

export const fetchUserByTaskerIdOrEmail = async (taskerIdOrEmail: string): Promise<any> =>
  await apiFetch(null, `corp-api/user_lookup/${taskerIdOrEmail}`);
